export class UIGeneralServicesController {
}
